// Carte d'information affichée lorsque l'identifiant d'offre (jobId)
// est absent de l'URL. On explique à l'utilisateur comment accéder au formulaire.
import React from 'react';

type Props = {
  t: Record<string, string>;
  siteUrl: string;
};

export function MissingOfferCard({ t, siteUrl }: Props) {
  return (
    <div className="card">
      <h2>{t.pageTitle}</h2>
      <p className="muted">
        {t.missingJobId}
      </p>
      <p>
        <a className="button" href={siteUrl} target="_blank" rel="noreferrer">
          {t.seeSite}
        </a>
      </p>
    </div>
  );
}

